/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import useOEmbed from 'hooks/useOEmbed';

function InstagramPost(props) {
  const { url, ...others } = props;
  const facebookAppId = useSelector(state => state.config.facebookId);
  const facebookClientToken = useSelector(state => state.config.facebookClientToken);

  const accessToken = encodeURIComponent(`${facebookAppId}|${facebookClientToken}`);
  const encodedUrl = encodeURIComponent(url);
  const oEmbedUrl = `https://graph.facebook.com/v20.0/instagram_oembed?url=${encodedUrl}&hidecaption=true&access_token=${accessToken}`;

  const { html, width } = useOEmbed({
    url: oEmbedUrl,
    loadScript: true,
    onLoad: () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    },
  });

  // eslint-disable-next-line react/no-danger
  return <div style={{ maxWidth: width }} dangerouslySetInnerHTML={{ __html: html }} {...others} />;
}

InstagramPost.propTypes = {
  url: PropTypes.string.isRequired,
};

export default InstagramPost;
